import { render, staticRenderFns } from "./AdminNbDashboard.vue?vue&type=template&id=c3f15f3e"
import script from "./AdminNbDashboard.vue?vue&type=script&lang=js"
export * from "./AdminNbDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports